module.exports = __webpack_public_path__ + "img/madeira-icon.e2e18992.png";